// extracted by mini-css-extract-plugin
export default {"fullWidth":"Select_fullWidth__4qzHs","select":"Select_select__cIX8Z"};